export const FirebaseConfig = {
	"projectId": "vaptvuptmob",
	"appId": "1:524134394748:web:9543ee9e8b9ca76addd2f9",
	"databaseURL": "https://vaptvuptmob-default-rtdb.firebaseio.com",
	"storageBucket": "vaptvuptmob.firebasestorage.app",
	"apiKey": "AIzaSyDjQC50HwMlVWIukE4OBVdok-qOMG9Gcf4",
	"authDomain": "vaptvuptmob.firebaseapp.com",
	"messagingSenderId": "524134394748",
	"measurementId": "G-K2PGM06N2B"
};